import {css} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    isSelected: boolean;
    label: string;
    onSelect: () => void;
}

export const HomeMatchPreferencesSurveyPill = (props: IProps) => {
    const {isSelected, label, onSelect} = props;

    return (
        <button aria-pressed={isSelected} className={pillStyle} onClick={onSelect} type="button">
            <span className={checkSlotStyle}>
                <CheckIcon fill="var(--colors-white)" size="1.6" />
            </span>
            <Text
                as="span"
                className={pillLabelStyle}
                color={isSelected ? "var(--colors-white)" : "var(--colors-secondary)"}
                preserveFontSize
                variant="info_txt_1"
            >
                {label}
            </Text>
        </button>
    );
};

const pillStyle = css({
    alignItems: "center",
    background: "transparent",
    border: "1px solid var(--colors-gray-600)",
    borderRadius: 1,
    cursor: "pointer",
    display: "inline-flex",
    height: "4.8rem",
    px: 2,
    transition: "background-color 200ms ease, border-color 200ms ease",

    "&[aria-pressed='true']": {
        backgroundColor: "var(--colors-secondary)",
        borderColor: "var(--colors-secondary)"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const pillLabelStyle = css({
    transition: "color 200ms ease",

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const checkSlotStyle = css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    marginRight: 0,
    minWidth: 0,
    opacity: 0,
    overflow: "hidden",
    transition: "width 200ms ease, margin-right 200ms ease, opacity 200ms ease",
    width: 0,

    "[aria-pressed='true'] &": {
        marginRight: 1,
        opacity: 1,
        width: "1.6rem"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});
import {css} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    isSelected: boolean;
    label: string;
    onSelect: () => void;
}

export const HomeMatchPreferencesSurveyPill = (props: IProps) => {
    const {isSelected, label, onSelect} = props;

    return (
        <button aria-pressed={isSelected} className={pillStyle} onClick={onSelect} type="button">
            <span className={checkSlotStyle}>
                <CheckIcon fill="var(--colors-white)" size="1.6" />
            </span>
            <Text
                as="span"
                className={pillLabelStyle}
                color={isSelected ? "var(--colors-white)" : "var(--colors-secondary)"}
                preserveFontSize
                variant="info_txt_1"
            >
                {label}
            </Text>
        </button>
    );
};

const pillStyle = css({
    alignItems: "center",
    background: "transparent",
    border: "1px solid var(--colors-gray-600)",
    borderRadius: 1,
    cursor: "pointer",
    display: "inline-flex",
    height: "4.8rem",
    px: 2,
    transition: "background-color 200ms ease, border-color 200ms ease",

    "&[aria-pressed='true']": {
        backgroundColor: "var(--colors-secondary)",
        borderColor: "var(--colors-secondary)"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const pillLabelStyle = css({
    transition: "color 200ms ease",

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const checkSlotStyle = css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    marginRight: 0,
    minWidth: 0,
    opacity: 0,
    overflow: "hidden",
    transition: "width 200ms ease, margin-right 200ms ease, opacity 200ms ease",
    width: 0,

    "[aria-pressed='true'] &": {
        marginRight: 1,
        opacity: 1,
        width: "1.6rem"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});
